var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<redi-window-frame>\n<div ng-controller=\"ErrorMessageController as ctrl\" class=\"error\">\n<div style=\"display:flex; flex-direction: row;\">\n<span style=\"font-size: 20px\">⚠️</span>\n<span class=\"errorMessage\">{{ ctrl.message }}</span>\n</div>\n</div>\n</redi-window-frame>\n";
var id1="views/error.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ../partials/views/error.html
// module id = 143
// module chunks = 0